import { InventoryAdjustmentUpdatePage } from '@/features/inventory-adjustment/pages/InventoryAdjustmentUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/inventory-adjustment/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["inventory_adjustment.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InventoryAdjustmentUpdatePage,
})
